<template>
  <main>
    <Trail
      :list="[
        {
          name: 'Facility',
          path: `/facilidad/${facility.slug}/sobre-observatorio-huancayo`,
          tag: `${facility.title}`,
        },
        {
          name: 'Facility',
          tag: `${currentSection.title}`,
        },
      ]"
    />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title v-if="currentSubsection.length !== undefined" tag="h1">{{
            currentSection.title
          }}</Title>
          <Title v-if="currentSubsection.length == undefined" tag="h1">{{
            currentSubsection.title
          }}</Title>
          <component :is="component" />
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(section, index) in sections" :key="index">
              <!-- Si no tiene subsecciones, es un enlace normal -->
              <a
                v-if="!section.subsections && section.path"
                :href="section.path"
                target="_blank"
              >
                {{ section.title }}
              </a>
              <router-link
                v-else-if="!section.subsections"
                :to="`/facilidad/${facility.slug}/${section.slug}`"
              >
                {{ section.title }}
              </router-link>

              <!-- Si tiene subsecciones, es un dropdown -->
              <div v-else>
                <span @click="toggleDropdown(index)">
                  {{ section.title }}
                  <i
                    class="ml-2"
                    :class="{
                      'rotate-180': activeDropdown === index,
                      'rotate-0': activeDropdown !== index,
                    }"
                  >
                    ▼
                  </i>
                </span>

                <!-- Dropdown subsecciones -->
                <ul
                  v-if="activeDropdown === index"
                  class="ml-4 mt-2 transition-all duration-300 ease-in-out"
                >
                  <li
                    v-for="(subsection, subIndex) in section.subsections"
                    :key="subIndex"
                  >
                    <router-link
                      v-if="currentSubsection.slug !== subsection.slug"
                      :to="
                        `/facilidad/${facility.slug}/${section.slug}/${subsection.slug}`
                      "
                    >
                      {{ subsection.title }}
                    </router-link>
                    <span v-else>
                      {{ subsection.title }}
                    </span>
                  </li>
                </ul>
              </div>
            </li>
          </List>
          <!-- V-if="$route.path, incia con '/facilidad/microfisica'" -->
          <div class="contact" v-if="$route.path === '/facilidad/microfisica'">
            <h3>Contacto</h3>
            <div class="contact--item">
              <IconPerson />
              {{ facility.contact.name }}
            </div>
            <div class="contact--item">
              <IconEmail />
              <div>
                <template
                  v-for="(email, index) in facility.contact.email"
                  :key="index"
                >
                  <a :href="`mailto:${email}`">
                    {{ email }}
                  </a>
                  <template v-if="index + 1 < facility.contact.email.length">
                    {{ ", " }}
                  </template>
                </template>
              </div>
            </div>
            <div class="contact--item">
              <IconPhone />
              {{ facility.contact.phone }} Anexo
              {{ facility.contact.annex }}
            </div>
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { ref } from "vue";
import { getFacilities } from "@/facilities.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import dinamicaAbout from "@/components/facility/dinamica/About";
import dinamicaModeling from "@/components/facility/dinamica/Modeling";
// import dinamicaCluster from "@/components/facility/dinamica/Cluster";
// import dinamicaResources from "@/components/facility/dinamica/Resources";
import dinamicaPublications from "@/components/facility/dinamica/Publications";
import microfisicaAboutHuancayo from "@/components/facility/microfisica/AboutHuancayo";
import microfisicaAboutLamar from "@/components/facility/microfisica/AboutLamar";
import microfisicaInstruments from "@/components/facility/microfisica/Instruments";
import microfisicaMonitoring from "@/components/facility/microfisica/Monitoring";
import microfisicaResources from "@/components/facility/microfisica/Resources";
import microfisicaProjects from "@/components/facility/microfisica/Projects";
import microfisicaPublications from "@/components/facility/microfisica/Publications";
//Instumentos
import microfisicaInstrumentosEstacionBSRN from "@/components/facility/microfisica/Instrumentos/EstacionBSRN";
import microfisicaInstrumentosEstacionMeteorologicaAutomatica from "@/components/facility/microfisica/Instrumentos/EstacionMeteorologicaAutomatica";
import microfisicaInstrumentosFotometroSolar from "@/components/facility/microfisica/Instrumentos/FotometroSolar";
import microfisicaInstrumentosCeilometro from "@/components/facility/microfisica/Instrumentos/Ceilometro";
import microfisicaInstrumentosEtalometro from "@/components/facility/microfisica/Instrumentos/Etalometro";
import microfisicaInstrumentosPerfiladorAerosoles from "@/components/facility/microfisica/Instrumentos/PerfiladorAerosoles";
import microfisicaInstrumentosMedidorOzono from "@/components/facility/microfisica/Instrumentos/MedidorOzono";
import microfisicaInstrumentosRadiometroUV from "@/components/facility/microfisica/Instrumentos/RadiometroUV";
import microfisicaInstrumentosRadarMIRA35C from "@/components/facility/microfisica/Instrumentos/RadarMIRA35C";
import microfisicaInstrumentosRadarClaire from "@/components/facility/microfisica/Instrumentos/RadarClaire";
import microfisicaInstrumentosDisdrometro from "@/components/facility/microfisica/Instrumentos/Disdrometro";
import microfisicaInstrumentosBLTR from "@/components/facility/microfisica/Instrumentos/BLTR";
import microfisicaInstrumentosPluviometro from "@/components/facility/microfisica/Instrumentos/Pluviometro";
import microfisicaInstrumentosTorreGradientes from "@/components/facility/microfisica/Instrumentos/TorreGradientes";
// End Intrumentos
// START: MONITOREO
import microfisicaMonitoreoRegistroParametrosAtmosfericos from "@/components/facility/microfisica/Monitoreo/RegistroParametrosAtmosfericos";
import microfisicaMonitoreoNubesPrecipitacionesPorRadar from "@/components/facility/microfisica/Monitoreo/NubesPrecipitacionesPorRadar";
import microfisicaMonitoreoVariablesRadiativas from "@/components/facility/microfisica/Monitoreo/VariablesRadiativas";
// Oculto
import microfisicaMonitoreoMonitoreoInterno from "@/components/facility/microfisica/Monitoreo/MonitoreoInterno";

// END: MONITOREO
import IconPerson from "@/components/ui/icons/IconPerson";
import IconEmail from "@/components/ui/icons/IconEmail";
import IconPhone from "@/components/ui/icons/IconPhone";
import { useRoute } from "vue-router";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    dinamicaAbout,
    dinamicaModeling,
    // dinamicaCluster,
    //dinamicaResources,
    dinamicaPublications,
    microfisicaAboutHuancayo,
    microfisicaAboutLamar,
    microfisicaInstruments,
    microfisicaMonitoring,
    microfisicaResources,
    microfisicaProjects,
    microfisicaPublications,
    microfisicaInstrumentosEstacionBSRN,
    microfisicaInstrumentosEstacionMeteorologicaAutomatica,
    microfisicaInstrumentosFotometroSolar,
    microfisicaInstrumentosCeilometro,
    microfisicaInstrumentosEtalometro,
    microfisicaInstrumentosPerfiladorAerosoles,
    microfisicaInstrumentosMedidorOzono,
    microfisicaInstrumentosRadiometroUV,
    microfisicaInstrumentosRadarMIRA35C,
    microfisicaInstrumentosRadarClaire,
    microfisicaInstrumentosDisdrometro,
    microfisicaInstrumentosBLTR,
    microfisicaInstrumentosPluviometro,
    microfisicaInstrumentosTorreGradientes,
    microfisicaMonitoreoRegistroParametrosAtmosfericos,
    microfisicaMonitoreoNubesPrecipitacionesPorRadar,
    microfisicaMonitoreoVariablesRadiativas,
    microfisicaMonitoreoMonitoreoInterno,
    IconPerson,
    IconEmail,
    IconPhone,
  },
  setup() {
    const route = useRoute();
    let component = "";
    let currentSection = "";
    let currentSubsection = "";
    const facility = getFacilities(process.env.VUE_APP_PREFIX)[
      route.params.facility
    ];

    const activeDropdown = ref(null);

    const toggleDropdown = (index) => {
      activeDropdown.value = activeDropdown.value === index ? null : index;
    };

    // Obtén todas las secciones de la instalación
    const sections = facility.sections;

    // Encuentra la sección actual usando el slug de la ruta
    currentSection =
      facility.sections.find(
        (section) => section.slug === route.params.section
      ) || facility.sections[0];

    // Verifica si la sección actual tiene subsecciones
    const subsections = currentSection.subsections;

    // Si hay subsecciones, encuentra la subsección actual
    if (subsections && subsections.length > 0) {
      currentSubsection =
        subsections.find(
          (subsection) => subsection.slug === route.params.subsection
        ) || subsections[0];
      component = `${route.params.facility}${currentSection.name}${currentSubsection.name}`;
    } else {
      component = `${route.params.facility}${currentSection.name}`;
    }

    return {
      facility,
      sections,
      currentSection,
      subsections,
      currentSubsection,
      component,
      toggleDropdown,
      activeDropdown,
    };
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.contact {
  &--item {
    display: grid;
    grid-template-columns: 25px auto;
    flex-wrap: wrap;
    margin: 0;
  }
  svg {
    margin-top: 0.4em;
  }
}

.list--marked {
  margin-bottom: 0px !important;
}

.contact {
  padding-top: 1.5rem;
}
</style>
